<template>
    <CCard>      
      <CCardBody>       
          <CRow>     
            <div class="form-group col-md-1">
            <span class="about-title" style="vertical-align: top; ">人員圖片</span>
            </div> 
            
           <div class="form-group col-md-5">
           <div class="c-avatar" style="height:300px; width: 300px; padding-left: 10px; text-align:left"><img v-bind:src="e_user_img_url" style="height:100%; width: 100%;" class="c-avatar-about-img" /></div> 
           

           <label class="btn btn-ghost-success" style="vertical-align: top;">
              <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageChange" accept="image/png, image/jpeg">
              <i class="e-info"><img width="60px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
            </label>

          </div> 
          <div class="form-group col-md-5">
            <div class="c-avatar" style="height:300px; width: 300px; padding-left: 10px; text-align:left"><img v-bind:src="e_sign_url" style="height:100%; width: 100%;" class="c-avatar-about-img" /></div> 
          </div>
            </CRow>
            <CRow>
             <div class="form-group col-md-6">
              <span class="about-title-verify">系統帳號</span>
              <ejs-textbox floatLabelType="Always" cssClass="my-textbox"  v-model="e_user_id" :enabled="false" aria-required="true"></ejs-textbox>  
            </div>                               
            <div class="form-group col-md-6">
              <span class="about-title-verify">所屬部門</span>
               <ejs-dropdownlist id='depts' cssClass="custom-dropdown"  :dataSource='deptDatas' :enabled="false" :fields='fields' v-model="e_dept_id" ></ejs-dropdownlist>
            </div>
            <div class="form-group col-md-6">   
              <span class="about-title-verify">人員名稱</span>
              <ejs-textbox floatLabelType="Always" cssClass="my-textbox" v-model="e_user_name" :enabled="false"  aria-required="true"></ejs-textbox>    
            </div>  
            <div class="form-group col-md-6">
              <span class="about-title">英文名稱</span>
              <ejs-textbox floatLabelType="Always" cssClass="my-textbox" v-model="e_user_name_en" aria-required="true"></ejs-textbox>    
            </div>                                    
            <div class="form-group col-md-6">
              <span class="about-title">電子信箱</span>
              <ejs-textbox floatLabelType="Always" v-model="e_email"  aria-required="true"></ejs-textbox>    
            </div>
            <div class="form-group col-md-6">
              <span class="about-title-verify">員工編號</span>
              <ejs-textbox floatLabelType="Always" v-model="e_preson_id" :enabled="false" aria-required="true"></ejs-textbox>    
            </div>
            <div class="form-group col-md-6">
              <span class="about-title">電話號碼</span>
              <ejs-textbox floatLabelType="Always" v-model="e_phone"  aria-required="true"></ejs-textbox>    
            </div>
            <div class="form-group col-md-6">
              <span class="about-title">手機號碼</span>
              <ejs-textbox floatLabelType="Always" v-model="e_cellphone"  aria-required="true"></ejs-textbox>    
            </div>   
            <div class="form-group col-md-12">
              <span class="about-title">註記</span>
              <ejs-textbox floatLabelType="Always" v-model="e_memo" aria-required="true"></ejs-textbox>    
            </div>   
        </CRow>
          <CRow  >
            <div class="form-group col-md-12" style="display: flex; justify-content: flex-end;">
              <ejs-button cssClass='e-primary' style="margin-left: 10px;font-size: 18px; padding: 12px 24px;" v-on:click.native='eSignClick'>簽名</ejs-button>
              <ejs-button cssClass='e-primary' style="margin-left: 10px;font-size: 18px; padding: 12px 24px;" v-on:click.native='editOkClick'>更新</ejs-button>
            </div>
            
          </CRow>
            <ejs-dialog ref="dialogSign" showCloseIcon='true' isModal='true' :visible='false'  width='680px' closeOnEscape='true' >
                <SignTemplate ref="mySignTemplate" v-on:onSignClose="onSignTemplateItem" style="justify-content: center; "></SignTemplate>
            </ejs-dialog>
          <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>   
      </CCardBody>   
    </CCard>
</template>
<script>

import Vue from "vue";
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { ButtonComponent } from '@syncfusion/ej2-vue-buttons';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import SignTemplate from "./Sign.vue";
import Loading from 'vue-loading-overlay'
Vue.use(Loading) // 這行一定要有
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.prototype.$eventHub = new Vue(); 
export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent,
    "ejs-button":ButtonComponent,
    SignTemplate
  },
  data: function () {
    return {
      Loader:null,
      e_selectRow : null, e_selectData: null,
      e_user_id: null, e_user_name : null,  e_dept_id: null, e_email: null, e_isAdd: null, e_no: null, e_name: null, e_state: null, e_phone: null, e_cellphone: null,
      e_user_img_url: null, e_user_img: null, e_preson_id: null, e_user_name_en: null, e_memo : null,e_sign_url:null,data:[],
      fields: { value: 'value', text: 'text' },
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: null, deptDatas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      imgPersonTemplate: function () { return { 
          template: Vue.component("imgPersonTemplate", {
          template:  `<div><img :src="image" class='c-avatar-about-img' style='width:30px' /></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.user_img_url;
              }
          }
      })}},     
    };
  },
  created(){
    this.GetOwner();
    this.getDeptData();
  },
 methods: {   
  //Sign
  eSignClick:function(){
    this.$eventHub.$emit('SetHeader',"簽名");  
    this.$eventHub.$emit('sign',this.data);  
    this.$refs.dialogSign.show(); 
  },
  onSignTemplateItem:function() {
        this.$refs.dialogSign.hide(); 
        this.GetOwner();
    },
  //api
  getDeptData: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/Department',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                    
          this.deptDatas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
  GetOwner(){
    this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: 'Account/Owner',
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
              console.log(response.data.datas)
              this.data=response.data.datas;
              this.e_user_id =response.data.datas.user_id;
              this.e_dept_id=response.data.datas.dept_id;
              this.e_user_name=response.data.datas.user_name;
              this.e_user_name_en=response.data.datas.user_name_en;
              this.e_email =response.data.datas.email;
              this.e_preson_id=response.data.datas.preson_id;
              this.e_phone =response.data.datas.phone;
              this.e_cellphone =response.data.datas.cellphone;
              this.e_memo =response.data.datas.memo;

              this.e_user_img_url =response.data.datas.user_img_url;
              this.e_sign_url = response.data.datas.sign_url;

          })
          .catch((error) => { this.showError(error, true) }
      ) 
  },
  fileImageChange: function(e) {
    let self = this;
    let formData = new FormData();           
    formData.append('file', e.target.files[0]);
    this.axios({
        method: 'post',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: 'Account/User/Upload',                   
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : formData
    })
    .then(function (response) { 
        self.e_user_img = response.data.datas;
        self.e_user_img_url = response.data.msg;
    })
    .catch((error) => { this.showError(error, false) })
  },  
  editOkClick: function() {     
      this.showLoading();
      this.axios({
          method:  'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/User',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            user_id: this.e_user_id,
            user_name: this.e_user_name,   
            dept_id: this.e_dept_id,
            preson_id:  this.e_preson_id,            
            email: this.e_email,
            state: this.e_state ? 1 : 2,          
            phone : this.e_phone,
            cell_phone : this.e_cellphone,
            user_img : this.e_user_img,            
            user_name_en : this.e_user_name_en,
            memo : this.e_memo
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        
        this.hideLoading();
        this.$refs.toastRef.show( { title: '成功!', content: response.data.msg, cssClass: 'e-toast-info', icon: 'e-warning toast-icons' });
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 

    },  
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showLoading() {
      this.Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        this.Loader.hide();
    }
  },

}

</script>